import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative bg-foreground-950 py-16 md:py-20 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-12">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-50/20 text-background-50/80 text-xs font-medium whitespace-nowrap w-fit">
            Trending Categories
          </span>
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              Curated Spreadsheet<br />Collection
            </h2>
          </div>
        </div>

        <div className="relative">
          <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory -mx-4 px-4 md:px-0 scrollbar-hide">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[200px] md:w-[220px] snap-start group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-2xl bg-secondary-200/80 aspect-[4/5]">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} - pandabuyspreadsheet category`}
                    title={`PandaBuy Spreadsheet - ${cat.name}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {/* Text overlay on image */}
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent pt-10 pb-3 px-3">
                    <h3 className="text-sm md:text-base font-bold text-white leading-tight">
                      {cat.name}
                    </h3>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}